import askAnswer from './ask_answer/zh'
import aiTranslate from './ai_translate/zh'
import creations from './creations/zh'
import aside from './component/aside/zh'
import header from './component/header/zh'
import history from './component/history/zh'
import subscribe from './component/subscribe/zh'
import toolInput from './component/toolInput/zh'
import payPopup from './component/pay_popup/zh'
import login from './component/login/zh'

export default {
  ...askAnswer,
  ...aiTranslate,
  ...creations,
  ...aside,
  ...header,
  ...history,
  ...subscribe,
  ...toolInput,
  ...payPopup,
  ...login
}
